"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Icon_1 = __importDefault(require("../Icon"));
var Link_1 = __importDefault(require("../Link"));
var Image_1 = __importDefault(require("../Image"));
var ImagePopover = (0, styled_1.default)(Image_1.default)({
    position: 'absolute',
    maxWidth: 'initial',
    height: 256,
    width: 256,
    bottom: 25,
    right: 0
});
var HoverableIcon = (0, styled_1.default)(Icon_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        '&>img': {
            display: 'none'
        },
        '&:hover>img': {
            display: 'block',
            zIndex: theme.zIndices.tooltip // z-index greater than the back-top
        },
    });
});
var SocialIcon = function (props) {
    var socialLinks = props.socialLinks;
    return (react_1.default.createElement("div", null, socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.map(function (item) { return (react_1.default.createElement(Link_1.default, { key: item.url, mx: 2 }, isImage(item.url)
        ?
            react_1.default.createElement(HoverableIcon, { name: item.icon },
                react_1.default.createElement(ImagePopover, { src: item.url, alt: "social icon" }))
        : react_1.default.createElement(Icon_1.default, { name: item.icon, color: "white", onClick: function () { return window.location.href = item.url; } }))); })));
};
function isImage(url) {
    return /\.(jpe?g|png|gif)$/i.test(url);
}
exports.default = SocialIcon;
